
import React, { Suspense, useEffect } from 'react';
import Routes from "./routes";
import "./config/i18n";
import { GrowthBook, GrowthBookProvider } from "@growthbook/growthbook-react";
const EtisalatTheme = React.lazy(() => import('./Themes/EtisalatTheme.js'));

const growthbook = new GrowthBook({

  apiHost: process.env.REACT_APP_GROWTH_BOOK_API_HOST,
  clientKey: process.env.REACT_APP_GROWTH_BOOK_CLIENT_KEY,
  enableDevMode: true
});


const ThemeSelector = ({ children }) => {
  return (
    <>
      <Suspense fallback={<div>Loading.......</div>}>
        <EtisalatTheme />
      </Suspense>
      {children}
    </>
  )
}
function App() {
  useEffect(() => {
    growthbook.init({ streaming: true })
    growthbook.setAttributes({ host: window.location.host });
  }, []);
  return (
    <GrowthBookProvider growthbook={growthbook}>
      <ThemeSelector>
        <Routes />
      </ThemeSelector>
    </GrowthBookProvider>
  );
}
export default App;
